import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Vehicle } from '../../../shared/model/vehicle';
import { VehicleService } from '../../service/vehicle.service';
import { DiagnosisWebSocketService } from '../../service/diagnosis-web-socket.service';
import { CustomerService } from '../../../shared/service/customer.service';
import { ToastService } from '../../../shared/service/toast.service';
import { Customer } from '../../../shared/model/customer';
import { DiagnosisService } from '../../service/diagnosis.service'
import { DiagnosisType } from '../../../shared/model/diagnosis-type';
import { MaterializeAction } from 'angular2-materialize';

declare var Materialize: any;

@Component({
  selector: 'tx-vehicle-select',
  templateUrl: './vehicle-select.component.html',
  styleUrls: ['./vehicle-select.component.css']
})
export class VehicleSelectComponent implements OnInit {
  selectedVehicle: Vehicle;
  customers: Array<Customer>;
  vehicles: Array<Vehicle>;
  customerAttributesTree = ['name'];
  disablePlateInput = true;
  disableCustomersInput = true;
  loadingOrgLabel = 'Selecione primeiro um Cliente';
  loadingCustomerLabel = 'Selecione primeiro um Tipo';
  diagnosticsTypes: Array<any>;
  diagnosticType: any;
  modalActions = new EventEmitter<string|MaterializeAction>();
  _customer: Customer;

  constructor(private _router: Router,
              private _vehicleService: VehicleService,
              private _customerService: CustomerService,
              private _diagnosisNotification: DiagnosisWebSocketService,
              private _toastService: ToastService, private _diagnosisService: DiagnosisService) { }

  ngOnInit() {
    this.setUpEmptyEntities();
    this.setUpVehiclesObserver();
    this.setUpCustomersObserver();
    this.getDiagnosticsTypes();
  }

  startDiagnosis() {
    if (this.selectedVehicle && this.diagnosticType) {
      let vehi = this.selectedVehicle;
      vehi.diagnosisType = this.diagnosticType;
      this.selectedVehicle = vehi;
      this.run();
    
    } else if (!this.selectedVehicle) {
      this._toastService.showMessage('Selecione uma placa!', 4000);
    } else if (!this.diagnosticType) {
      this._toastService.showMessage('Selecione um Tipo de Diagnóstico!', 4000);
    }
  }

  getVehicles(customer: Customer) {
    this._customer = customer;
    this._diagnosisNotification.setCustomer(customer);
    this._vehicleService.getVehiclesByUser(customer.trixUser.id, this.diagnosticType);
    this.loadingOrgLabel = 'Carregando...';
  }

  getCustomersBasedOn(name: string) {
    this._customerService.getCustomersBasedOn(name);
  }

  selectVehicle(vehicle: Vehicle) {
    vehicle.diagnosisType = this.diagnosticType;
    this.selectedVehicle = vehicle;
  }

  setDiagnosticType(diagnosticType) {
    this.diagnosticType = diagnosticType;
    this.disableCustomersInput = false;
    if (this._customer) {
      this.getVehicles(this._customer);
    }
  }

  private setUpEmptyEntities() {
    this.customers = new Array();
    this.vehicles = new Array();
    this.diagnosticsTypes = new Array();
  }

  private setUpVehiclesObserver() {
    this._vehicleService.find$
      .subscribe(vehicles => {
        this.vehicles = vehicles;
        this.disablePlateInput = false;
      });
  }

  private setUpCustomersObserver() {
    this._customerService.find$
      .filter(data => data instanceof Array)
      .subscribe((customers: Array<Customer>) => this.customers = customers);
  }

  private getDiagnosticsTypes() {
    this._diagnosisService.getDiagnosisticsTypes()
      .subscribe(
        (response: any) => {
          this.diagnosticsTypes = Object.assign(new Array<String>(), JSON.parse(response._body));
        },
        error => this.diagnosticsTypes = undefined
      );
  }

  private run() {
    if (this.selectedVehicle.diagnosisType == DiagnosisType.GENERAL) {
      this.goToDiagnosisComponent()
    } else if (this.selectedVehicle.diagnosisType == DiagnosisType.SIMPLIFIED) {
      this.modalActions.emit({ action: 'modal', params: ['open'] });
    }
  }

  goToDiagnosisComponent() {
    this._router.navigate(
      ['diagnosis/run', { data: JSON.stringify({vehicle: this.selectedVehicle, vehicles: this.vehicles, showTitle: true}) }]);
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/diagnosis/component/vehicle-select/vehicle-select.component.ts